import { getStores } from '../stores';

export default {
  close: () => getStores().view.closeModal(),
  setLoading: (isLoading) => getStores().view.setLoading(isLoading),
  getParams: () => getStores().view.getParams(),
  setParams: (params) => getStores().view.setParams(params),
};
